"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
var _react = _interopRequireDefault(require("react"));
var _PctyQuestionBuilder = require("./PctyQuestionBuilder.Common");
var _PctyQuestionBuilder2 = require("./PctyQuestionBuilder.Constants");
var _rating = require("@citrus/rating");
var _inputTextfield = require("@citrus/input-textfield");
var _questionBuilder = require("@pcty/question-builder");
var _PctyQuestionBuilderEdit = _interopRequireDefault(require("./PctyQuestionBuilder.Edit.QuestionOptions"));
var Presentational = function Presentational(_ref) {
  var id = _ref.id,
    builderType = _ref.builderType,
    scenario = _ref.scenario,
    question = _ref.question,
    required = _ref.required,
    editable = _ref.editable,
    onQuestionUpdated = _ref.onQuestionUpdated,
    hint = _ref.hint,
    number = _ref.number,
    value = _ref.value,
    options = _ref.options,
    minimumRateLabel = _ref.minimumRateLabel,
    maximumRateLabel = _ref.maximumRateLabel,
    questionCommentsEnabled = _ref.questionCommentsEnabled,
    allowComments = _ref.allowComments,
    commentsPlaceholder = _ref.commentsPlaceholder;
  var questionTypeId = _questionBuilder.QUESTION_TYPE.ratingScale;
  var onQuestionTextUpdated = function onQuestionTextUpdated(questionText) {
    if (onQuestionUpdated) onQuestionUpdated({
      questionText: questionText
    });
  };
  var onOptionsUpdated = function onOptionsUpdated(edit) {
    var options = edit ? edit.options : [];
    if (onQuestionUpdated) onQuestionUpdated({
      options: options
    });
  };
  var onChangeRatingMinimumLabel = function onChangeRatingMinimumLabel(_ref2) {
    var id = _ref2.id,
      value = _ref2.value;
    if (onQuestionUpdated) onQuestionUpdated({
      minimumRateLabel: value
    });
  };
  var onChangeRatingMaximumLabel = function onChangeRatingMaximumLabel(_ref3) {
    var id = _ref3.id,
      value = _ref3.value;
    if (onQuestionUpdated) onQuestionUpdated({
      maximumRateLabel: value
    });
  };
  var getRatingScaleMinMaxLabels = function getRatingScaleMinMaxLabels() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "pcty-row pcty-margin-top pcty-padding-bottom"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "pcty-col-xs-6"
    }, /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
      className: "pcty-question-builder-rating-label",
      id: "".concat(id, "-rating-label-minimum"),
      label: "Minimum Rating Label",
      maxLength: 50,
      onChange: onChangeRatingMinimumLabel,
      value: minimumRateLabel
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "pcty-col-xs-6"
    }, /*#__PURE__*/_react.default.createElement(_inputTextfield.Textfield, {
      className: "pcty-question-builder-rating-label",
      id: "".concat(id, "-rating-label-maximum"),
      label: "Maximum Rating Label",
      maxLength: 50,
      onChange: onChangeRatingMaximumLabel,
      value: maximumRateLabel
    }))));
  };

  // setup our dummy edit container for the options' inline-editing
  var edit = {
    options: options,
    typeId: questionTypeId
  };
  var validationState = (0, _PctyQuestionBuilder.validate)(edit, true, builderType);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _PctyQuestionBuilder.renderHint)(id, hint), (0, _PctyQuestionBuilder.renderScenario)(id, scenario), (0, _PctyQuestionBuilder.renderQuestion)(id, questionTypeId, number, question, required, editable, onQuestionTextUpdated), editable ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilderEdit.default, {
    id: id,
    builderType: builderType,
    edit: edit,
    maximumItemCount: _PctyQuestionBuilder2.MAXIMUM_RATING_SCALE_ITEMS,
    validationState: validationState,
    onOptionsChange: onOptionsUpdated
  }), getRatingScaleMinMaxLabels()) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "pcty-level-1-footnote"
  }, minimumRateLabel), /*#__PURE__*/_react.default.createElement("span", {
    className: "pcty-level-1-footnote pcty-float-right"
  }, maximumRateLabel), /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-qb-rating-scale-buttons"
  }, /*#__PURE__*/_react.default.createElement(_rating.ButtonRating, {
    id: id,
    items: options.map(function (itm, index) {
      return {
        id: itm.id,
        value: index + 1,
        label: itm.value
      };
    }),
    value: value
  }))), (0, _PctyQuestionBuilder.renderQuestionComment)(id, allowComments, commentsPlaceholder, editable, questionCommentsEnabled, onQuestionUpdated));
};
var _default = exports.default = Presentational;